<div class="container-wrapper">
  <!-- <div class="navbar">
    <app-navbar></app-navbar>
  </div> -->
  <div class="main">
    <div class="sidebar">
      <app-sidebar></app-sidebar>
    </div>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
